@if (tabs$ | async; as tabs) {
  <tui-tabs *transloco="let t" size="m" [activeItemIndex]="selectedIndex$ | async">
    @for (tab of tabs; track tab.value; let index = $index) {
      <button tuiTab type="button" (click)="onTabChange(tab, index)">
        {{ t(tab.display) }}
      </button>
    }
  </tui-tabs>
}
